export const GET_USERS_RETURN = 'GET_USERS_RETURN';
export const GET_USERS_SAGAS = 'GET_USERS_SAGAS';

export const PUT_USER_RETURN = 'PUT_USER_RETURN';
export const PUT_USER_SAGAS = 'PUT_USER_SAGAS';

export const DELETE_USER_RETURN = 'DELETE_USER_RETURN';
export const DELETE_USER_SAGAS = 'DELETE_USER_SAGAS';

/********** USERS GET ALL ****************/
export const getUsersSagas = (xAccess, page, range, filters) => ({
	type: GET_USERS_SAGAS,
	token: xAccess,
	page,
	range,
	filters
});
export const getUsersReturn = (result) => ({
	type: GET_USERS_RETURN,
	payload: result
});

/********** USERS UPDATE ****************/
export const putUserSagas = (uuid, xAccess, data) => ({
	type: PUT_USER_SAGAS,
	token: xAccess,
	payload: uuid,
	data: data
});
export const putUserReturn = (result) => ({
	type: PUT_USER_RETURN,
	payload: result
});

/********** USERS DELETE ****************/
export const deleteUserSagas = (uuid, xAccess) => ({
	type: DELETE_USER_SAGAS,
	token: xAccess,
	payload: uuid
});
export const deleteUserReturn = (result) => ({
	type: DELETE_USER_RETURN,
	payload: result
});
